import Cookies from 'js-cookie';

import cookieJar from 'scripts/application/lib/cookie_jar';

export default function() {
  cookieJar.get = Cookies.get;

  return cookieJar;
}
